import { gql } from '@apollo/client'

export const DROPDOWN_PROCESSINGS_QUERY = gql`
  query dropdownProcessings($sortBy: ProcessingSort, $filter: ProcessingFilter) {
    processings(sortBy: $sortBy, filter: $filter) {
      collection {
        id
        processingStep
        assignedProcessingType {
          intern
        }
      }
    }
  }
`
